export default class AgingTierScale {
    static default() {
        return new AgingTierScale([
            {code: '1_to_7', label: '0 a 7 días'},
            {code: '8_to_15', label: '+7 a 15'},
            {code: '16_to_21', label: '+15 a 21'},
            {code: '22_to_30', label: '+21 a 30'},
            {code: '31_to_90', label: '+30 a 90'},
            {code: 'over_90', label: '+90'},
            {code: 'prejudicial_management', label: 'Pre Gestión Judicial'},
            {code: 'judicial_management', label: 'Gestión Judicial'},
        ]);
    }

    constructor(overdueTiers) {
        this._overdueTiers = overdueTiers;
    }

    overdueTiers() {
        return this._overdueTiers;
    }

    tiersCount() {
        return this._overdueTiers.length + 1;
    }

    labelOf(tierCode) {
        return this._tierWith(tierCode).label;
    }

    severityOf(tierCode) {
        return this._overdueTiers.findIndex(tier => tier.code === tierCode) + 1;
    }

    colorOf(tierCode, theme) {
        const CANCELLED_TIER_CODE = 'cancelled';
        if (tierCode === CANCELLED_TIER_CODE) {
            return theme.palette.text.secondary;
        }
        return theme.brand.agingRamp[this.severityOf(tierCode)];
    }

    _tierWith(tierCode) {
        return this._overdueTiers.find(tier => tier.code === tierCode);
    }
}
